export default __webpack_public_path__ + "static/media/react.0b093e51.svg";